const BoxColor = (props: any) => {

  let active = props.active ?? '';
  let color = props.color ?? "";

  const clickBox = () => {
    props.handelClick(color);
  }

  return (
    <div onClick={clickBox} style={{ backgroundColor: color }} className={`BoxColor d-inline-block ${active ? "active" : ''}`}>
      <span className="material-symbols-outlined">
        done
      </span>
    </div>
  )
}

export default BoxColor